import baguetteBox from 'baguettebox.js';

export default function () {
    var imageGallery = document.getElementById('imageGallery');

    if (imageGallery != null) {
        baguetteBox.run('.c-gallery', {
            buttons: true,
            captions: false
        });
    };
}
